var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('img',{attrs:{"src":require("../../assets/imgs/bg_left.png"),"width":"340px","height":"400px"}}),_c('div',{staticClass:"logform animated bounceInDown"},[_c('h1',[_vm._v("检测检查SaaS系统")]),_c('tz-form',{attrs:{"formConfig":_vm.formConfig,"formBtns":_vm.formBtns},on:{"submit":_vm.submitFn}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }